export default {"src":"/_next/static/media/not-found-error.5a0984b8.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};